import React, { Suspense } from 'react';

import type { Props } from './MobileMenuModalClient';

const MobileMenuModalClient = !process.env.SERVER
  ? process.env.NODE_ENV === 'test'
    ? require('./MobileMenuModalClient').default
    : React.lazy(() => import('./MobileMenuModalClient'))
  : null;

function MobileMenuModal(props: Props) {
  if (MobileMenuModalClient === null || !props.isOpen) return null;

  if (process.env.NODE_ENV === 'test') {
    const TestMobileMenuModalClient = MobileMenuModalClient as React.ComponentType<Props>;
    return <TestMobileMenuModalClient {...props} />;
  }

  return (
    <Suspense fallback={null}>
      <MobileMenuModalClient {...props} />
    </Suspense>
  );
}

export default MobileMenuModal;
